// src/api/idClient.ts
import { fetchBaseQuery } from '@reduxjs/toolkit/query'

const ID_URL = import.meta.env.VITE_ID_URL
if (!ID_URL && import.meta.env.PROD) {
  throw new Error('VITE_ID_URL is required in production')
}

export const idBaseQuery = fetchBaseQuery({
  baseUrl: ID_URL ?? '/id/api/v1',
  credentials: 'include',
})
